<template>
  <v-row
    class="text-center articles-container section_inner mt-2"
    :class="{
      'justify-space-between': this.$vuetify.breakpoint.lgAndUp,
    }"
  >
    <v-col
      v-for="article in articles"
      :key="article.id"
      class="article-tip pointer"
      cols="12"
      lg="4"
      sm="4"
      @click="openVideo(article.videoSrc, article.Title)"
    >
      <v-icon class="play-icon" color="#ffffff" size="68">
        mdi-play-circle-outline
      </v-icon>
      <span class="white--text img-text pa-2">{{ article.title }}</span>
      <v-img
        class="rounded article-img"
        :src="article.imageSrc"
      ></v-img>
    </v-col>
  </v-row>
</template>


<script>
import { MENTORS_ARTICLES } from '@/lib/api.js';
import gtm from '@/lib/gtm';

export default {
  data() {
    return {
      articles: [],
    };
  },
  async fetch() {
    try {
      const { data: { data: data } } = await this.$axios.get(MENTORS_ARTICLES);
      const temp = data.articlesByCategory.articles.filter((article) => article.videoSrc).slice(0, 3);

      this.articles = temp;
    } catch (e) {
      console.log('Error=>', e);
    }
  },
  methods: {
    openVideo(videoSrc, videoTitle) {
      /** popup video data layer */
      const dataLayer = {
        category: 'video',
        action: videoTitle,
        event: 'video',
      };
      // // gtm(_dataLayer);
      gtm(dataLayer);

      this.$nuxt.$emit('openVideo', videoSrc);
    },
  },
};
</script>

<style lang="scss" scoped>
.articles-container {
  justify-content: space-evenly;
}
.article-tip {
  display: grid;
  grid-template-rows: repeat(3, 33.3%);
  grid-template-columns: 1fr 60% 1fr;
  max-width: 411px;
  &:hover {
    box-shadow: rgb(0 0 0 / 15%) 0 0 2px 2px;
  }
  .article-img {
    filter: brightness(0.5);
    grid-row: 1/-1;
    grid-column: 1/-1;
    min-height: 226px;
    max-height: 226px;
    @media only screen and (min-width: 600px) {
      min-height: 226px;
      max-height: 286px;
    }
  }
  .play-icon {
    grid-row: 2;
    grid-column: 2/3;
    z-index: 1;
  }
  .img-text {
    grid-row: 3;
    grid-column: 1/-1;
    align-self: center;
    z-index: 1;
    font-size: 24px;
  }
}
@media only screen and (min-width: 1264px) {
  .article-tip {
    padding: 0 !important;
  }
}
@media only screen and (max-width: 960px) {
  .img-text {
    font-size: 17px !important;
  }
}
@media only screen and (max-width: 800px) {
  .play-icon {
    font-size: 47px !important;
  }
}
@media only screen and (max-width: 600px) {
  .articles-container {
    flex-direction: column;
    align-items: center;

    .article-tip {
      width: 326px;
    }
  }
}
</style>